/* eslint-disable no-template-curly-in-string */
import R from 'ramda'

const FACEBOOK_RECURRING_OPTIN_DISPLAY_TYPE = 'Opt FB User in - Recurring'
const FACEBOOK_RECURRING_OPTIN_WIDGET_TYPE = 'FB_OPT_IN_RECURRING'

const isFacebookRecurringOptInFormAction = R.propEq(
  'type',
  FACEBOOK_RECURRING_OPTIN_DISPLAY_TYPE
)

const convertFacebookRecurringOptInActionToWidgetAction = R.applySpec({
  type: R.always(FACEBOOK_RECURRING_OPTIN_WIDGET_TYPE)
})

export {
  isFacebookRecurringOptInFormAction,
  convertFacebookRecurringOptInActionToWidgetAction
}



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/actions/facebook/form-to-widget/facebook-recurring-optin.js